module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn bg-maroon btn-flat margin",
    attrs: {
      "id": "myButton",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clickBtn
    }
  }, [(_vm.loading) ? [_vm._v(_vm._s(_vm.msgBye))] : [_vm._v(_vm._s(_vm.msgHello))]], 2)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Demo list")]), _vm._v(" "), _c('h3', [_vm._v("Dashboard")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("헬로화면")]), _vm._v(" "), _c('li', [_vm._v("샘플화면")]), _vm._v(" "), _c('li', [_vm._v("Dashboard v1")]), _vm._v(" "), _c('li', [_vm._v("Dashboard v2")]), _vm._v(" "), _c('li', [_vm._v("InfoBox")]), _vm._v(" "), _c('li', [_vm._v("Chart.js")]), _vm._v(" "), _c('li', [_vm._v("Alert")]), _vm._v(" "), _c('li', [_vm._v("Modal")]), _vm._v(" "), _c('li', [_vm._v("APIExample")])]), _vm._v(" "), _c('h3', [_vm._v("Widgets")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("all")])]), _vm._v(" "), _c('h3', [_vm._v("UI Elements")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("General")]), _vm._v(" "), _c('li', [_vm._v("Buttons")])]), _vm._v(" "), _c('h3', [_vm._v("Forms")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("General Elements")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f5ba1f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 897
// module chunks = 0